import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Box, Button, DashboardModule } from '@domain-group/suit-theme'

import { useFilters } from '@domain-group/react-hooks'

import useAgencyProviderDeadlineGroup from '@hooks/useAgencyProviderDeadlineGroup'
import useAgencyProviderDeadlineGroups from '@hooks/useAgencyProviderDeadlineGroups'

import ScopedConditionalContent from '@components/ScopedConditionalContent'

import defaultRequestOptions from '@sections/Admin/packs/SystemManager/defaultRequestOptions'

import AgencyProviderDeadlineGroupListItem from './AgencyProviderDeadlineGroupListItem'

const AgencyProviderDeadlineGroups = (props) => {
  const { agencyId } = props

  const filterPayload = useFilters()
  const { pageFilters } = filterPayload

  const agencyProviderDeadlineGroupsPayload = useAgencyProviderDeadlineGroups({
    filters: {
      agency_id: agencyId,
      ...pageFilters,
    },
    performHttpRequests: !!agencyId,
    requestOptions: defaultRequestOptions.agencyProviderDeadlineGroup,
  })

  const {
    callbacks: { createOrEditAgencyProviderDeadlineGroup },
  } = useAgencyProviderDeadlineGroup({ agency_id: agencyId })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredAgencyProviderDeadlineGroups,
    filteredAgencyProviderDeadlineGroupsCount,
    hasFilteredAgencyProviderDeadlineGroups,
    loading,
  } = agencyProviderDeadlineGroupsPayload

  return (
    <DashboardModule
      boxProps={{ id: 'realhub-nav-deadline-groups' }}
      loading={loading}
      title="Deadline Groups"
    >
      <Box flexDirection="column">
        {!loading && (
          <DashboardModule.ScrollableSection>
            {hasFilteredAgencyProviderDeadlineGroups && (
              filteredAgencyProviderDeadlineGroups.map(agencyProviderDeadlineGroup => (
                <AgencyProviderDeadlineGroupListItem
                  agencyProviderDeadlineGroup={agencyProviderDeadlineGroup}
                  key={agencyProviderDeadlineGroup.id}
                />
              ))
            )}

            {!hasFilteredAgencyProviderDeadlineGroups && (
              <DashboardModule.BlankState>
                <DashboardModule.BlankState.Title>
                  No Deadline Groups present
                </DashboardModule.BlankState.Title>

                <ScopedConditionalContent permittedRoleTitles={['Admin', 'Support']}>
                  <DashboardModule.BlankState.Paragraph>
                    Please adjust your filters or assign a Deadline Group.
                  </DashboardModule.BlankState.Paragraph>
                </ScopedConditionalContent>
              </DashboardModule.BlankState>
            )}
          </DashboardModule.ScrollableSection>
        )}

        <DashboardModule.LoadMoreFooter
          boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
          callbacks={{ loadMore }}
          canLoadMore={canLoadMore}
          entityCount={filteredAgencyProviderDeadlineGroupsCount}
          loading={loading}
        >
          <ScopedConditionalContent permittedRoleTitles={['Admin', 'Support']}>
            <Button
              buttonStyle="secondaryEdit"
              icon={<FontAwesomeIcon icon={faPlus} />}
              onClick={() => createOrEditAgencyProviderDeadlineGroup()}
              size={['medium', 'small']}
              width={['100%', 'fit-content']}
            >
              Add Deadline Group
            </Button>
          </ScopedConditionalContent>
        </DashboardModule.LoadMoreFooter>
      </Box>
    </DashboardModule>
  )
}

AgencyProviderDeadlineGroups.propTypes = {
  agencyId: PropTypes.number.isRequired,
}

export default AgencyProviderDeadlineGroups
